<template>
  <div
    :class="[
      'styled-html',
      '*:not-last:mb-4',
      '[&_:is(h1,h2,h3,h4,h5,h6)]:not-first:mt-8',
      '[&_ol]:pl-[2ch]',
      '[&_ol_li]:list-[inherit]',
      '[&_ul]:flex [&_ul]:list-none [&_ul]:flex-col [&_ul]:gap-4 [&_ul]:pl-ch',
      '[&_ul_li]:pl-ch',
      '[&_ul_li::marker]:text-primary-900',
      '[&_h1]:text-3xl',
      '[&_:is(h2,h3,h4)]:text-xl',
      '[&_:is(h5,h6)]:text-sm',
      '[&_:is(h1,h2,h3,h4,h5,h6)]:font-bold',
      '[&_:is(h1,h2,h3,h4,h5,h6)]:text-primary-900',
    ]"
  >
    <slot></slot>
  </div>
</template>

<style scoped>
.styled-html {
  :deep() {
    ul {
      li {
        &::marker {
          content: '\f054';
          font-family: 'Font Awesome 7 Pro';
        }
      }
    }
  }
}
</style>
